export function demoModal() {
	const menuButton = document.querySelectorAll('a[href="#demo-popup"]');
	const modalMenu = document.querySelectorAll('.modal--demo');

	if(window.location.hash === '#demo-popup') {
		modalMenu.forEach((menu) => {
			modalToggle(menu);
		});
	}

	function modalToggle(menu) {
		if (!menu.open) {
			menu.showModal();
			return;
		}
		if (menu.open) {
			menu.close();
		}
	}

	menuButton.forEach((button) =>
		button.addEventListener('click', (e) => {
			modalMenu.forEach((menu) => {
				modalToggle(menu);
			});
		})
	);

	modalMenu.forEach((menu) => {
		const closeButton = menu.querySelector('.modal__button--close');
		closeButton.addEventListener('click', (e) => {
			modalToggle(menu);
		});
	});
}
